
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    position: relative;

    margin-left: auto;

    margin-right: auto;

    display: block;

    max-width: max-content;

    padding: 1rem;
}

  :host ul {

    grid-auto-columns: minmax(0, 1fr);
}

  :host ul {

    grid-auto-flow: column;
}

  @media (min-width: 1024px) {

    :host ul {

        display: grid;
    }
}

  :host ul li {

    display: flex;
}

  :host ul li {

    max-width: 450px;
}

  :host ul li {

    padding-top: 2rem;

    padding-bottom: 2rem;
}

  @media (min-width: 1024px) {

    :host ul li {

        padding-top: 4rem;

        padding-bottom: 4rem;
    }
}

:host([bg-color='dark']) {

    border-radius: 0.75rem;

    background-color: var(--primary-blue);

    color: var(--neutral-white);
}

:host([bg-color='dark']) * {

    color: var(--neutral-white);
}

:host([bg-color='light-blue']) {

    border-radius: 0.75rem;

    background-image: var(--light-blue-gradient);

    color: var(--primary-blue);
}

:host([bg-color='light-blue']) * {

    color: var(--primary-blue);
}

:host([bg-color='white']) {

    border-radius: 0.75rem;

    background-color: var(--neutral-white);

    color: var(--primary-blue);
}

:host([bg-color='white']) * {

    color: var(--primary-blue);
}

:host([bg-color='']) {

    border-radius: 0.75rem;

    background-color: var(--neutral-transparent);
}

.infographics-card-icon {

    width: 150px;

    justify-content: center;

    padding: 0.5rem;
}

.infographics-card-icon ghs-icon {

    width: 100%;
}

.infographics-card-content {

    width: 50%;

    padding: 0.75rem;
}

li .info_headline {

    white-space: nowrap;
}

li .info_headline {

    padding-bottom: 0.5rem;
}

li .info_headline {

    font-family: var(--ff-display);
}

li .info_headline {

    font-size: var(--fs-h1-small);

    line-height: var(--lh-h1-small);
}

li .info_headline {

    font-weight: var(--fw-bold);
}

@media (min-width: 1280px) {

    li .info_headline {

        font-size: var(--fs-h1);

        line-height: var(--lh-h1);
    }
}

li .info_body {

    font-family: var(--ff-display);
}

li .info_body {

    font-size: var(--fs-h5-small);

    line-height: var(--lh-h5-small);
}

li .info_body {

    font-weight: var(--fw-bold);
}

:host([site='BH'][bg-color='dark']) {

    background-color: var(--bh-brand-primary-dark);

    color: var(--bh-neutral-white);
}

:host([site='BH'][bg-color='dark']) * {

    color: var(--bh-neutral-white);
}

:host([site='BH'][bg-color='light-blue']) {

    background-image: var(--bh-gradient-lightblue-bl-tr);

    color: var(--bh-brand-primary-dark);
}

:host([site='BH'][bg-color='light-blue']) * {

    color: var(--bh-brand-primary-dark);
}

:host([site='BH'][bg-color='white']) {

    background-color: var(--bh-neutral-white);

    color: var(--bh-brand-primary-dark);
}

:host([site='BH'][bg-color='white']) * {

    color: var(--bh-brand-primary-dark);
}

:host([site='BH']) li .info_headline {

    font-family: var(--bh-ff-body);
}

:host([site='BH']) li .info_body {

    font-family: var(--bh-ff-display);
}
`;